import { render, staticRenderFns } from "./ComparisonGroups.vue?vue&type=template&id=280d2392&scoped=true&"
import script from "./ComparisonGroups.vue?vue&type=script&lang=js&"
export * from "./ComparisonGroups.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonGroups.vue?vue&type=style&index=0&id=280d2392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d2392",
  null
  
)

export default component.exports